(function () {
    'use strict';
    angular.module('finansApp.employeeMenuController', []).controller('employeeMenuController', employeeMenuController);
    
    employeeMenuController.$inject = ['employeeService'];


    function employeeMenuController(employeeService) {
        var vm = this;
        vm.state = employeeService.state;
        vm.state.hasFilter = false;
        vm.state.currentFilter = angular.copy(vm.state.selectedDepartments);

        vm.clearFilter = function() {
            vm.state.selectedDepartments = {};
            vm.state.currentFilter = {};
            vm.state.hasFilter = false;

            employeeService.filterEmployees(); 
        }
        vm.changeFilter = function(id, name) {
            vm.state.hasFilter = true;
            vm.state.selectedDepartments = {};
            vm.state.selectedDepartments[id] = name;

            vm.state.currentFilter = angular.copy(vm.state.selectedDepartments);


            employeeService.filterEmployees();
        }


    }

})();